// extracted by mini-css-extract-plugin
export default {"field":"RichText_field__IgE3t","label":"RichText_label__wEUxC","editor":"RichText_editor__dLDgN","view":"RichText_view__0hLfm","plain":"RichText_plain__-HyMY"};